<template>
  <div class="row">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :opacity="0.85"
      :is-full-page="true"
    ></loading>
    <div class="col-12">
      <card
        :title="title"
        :subTitle="subTitle"
        :showFilter="showFilter"
        :filterInputValue="filterTerm"
      >
        <div slot="raw-content" class="table-responsive">
          <paper-table
            :data="displayData"
            :loading="loading"
            :columns="columns"
            :hasActions="hasActions"
            :actions="actions"
            :totalItems="totalItems"
            @changePage="changePage"
            @deleteClick="deleteClick"
            customAction1="View Questions"
            @customAction1Clicked="viewQuestionsClicked"
          ></paper-table>
        </div>
        <div class="row">
          <div class="col text-right">
            <input
              id="typeCounts"
              type="checkbox"
              v-model="showTypeCounts"
              @click="toggleShowTypeCounts()"
              class="pull-right mt-3 ml-3"
            />
            <label for="typeCounts"> &nbsp;Show Type Counts</label>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import odata from "@/services/odata.vue";
import { PaperTable } from "@/components";
import { db, getCustomer } from "@/db";
import utils from "@/utils";
import store from "@/router/store";

const tableColumns = ["Name", "Count"];

export default {
  components: {
    PaperTable,
    Loading,
  },
  props: {},
  data() {
    return {
      showTypeCounts: false,
      loading: true,
      title: "Asset Types",
      subTitle: `All ${store.getters.selectedCustomer.CustomerName} asset types are listed below`,
      hasActions: true,
      actions: {
        edit: false,
        delete: false,
      },
      columns: [...tableColumns],
      allData: [],
      allAssets: [],
      displayData: [],
      filteredData: [],
      isLoading: false,
      currentPage: 1,
      totalItems: 1,
      showFilter: false,
      filterTerm: "",
      assetCountDict: {},
    };
  },
  watch: {
    allData: {
      immediate: true,
      handler(allData) {
        if (allData.length > 0) {
          this.loading = false;
        }

        this.populateAssetCountDict();
        this.filterData(false);
      },
    },
    allAssets: {
      immediate: true,
      handler(assets) {
        if (assets.length > 0) {
          this.populateAssetCountDict();
          this.filterData(false);
        }
      },
    },
    filterTerm: {
      immediate: true,
      handler(filterTerm) {
        this.filterData(true);
      },
    },
  },
  firestore() {
    setTimeout(() => {
      this.loading = false;
    }, 3000);

    return {
      allData: getCustomer().collection("assettypes"),
      allAssets: getCustomer().collection("assets"),
    };
  },
  methods: {
    loadPage(num) {
      this.isLoading = true;
      if (!num) num = this.currentPage;
      let take = 10;
      this.displayData = utils.paginate(this.filteredData, take, num);
      this.isLoading = false;
    },
    filterData(resetPage = false) {
      var search = this.filterTerm.toUpperCase();
      var result = this.allData.filter((f) => {
        return f.AssetTypeName.toUpperCase().includes(search);
      });

      this.filteredData = result
        .sort(function (a, b) {
          return a.AssetTypeName.toUpperCase() > b.AssetTypeName.toUpperCase()
            ? 1
            : -1;
        })
        .map((c) => {
          return {
            Name: utils.getTypeHtml(c.AssetTypeName, c.AssetTypeName),
            Count: this.getAssetCount(c.AssetTypeName),
            Id: c.Id,
          };
        });

      this.totalItems = this.filteredData.length;
      
      if (resetPage) {
        this.currentPage = 1;
      } else {
        let maxPage = Math.ceil(this.totalItems / 10);
        if (maxPage === 0) maxPage = 1;
        if (this.currentPage > maxPage) {
          this.currentPage = maxPage;
        }
      }
      
      this.loadPage(this.currentPage);
    },
    changePage(pageNum) {
      this.currentPage = pageNum;
      this.loadPage(pageNum);
    },
    viewQuestionsClicked(id) {
      this.$router.push(`/questions/${id}`);
    },
    deleteClick(id, description) {
      if (
        window.confirm(
          `Are you sure you want to delete the asset type '${description}'?`
        )
      ) {
        this.isLoading = true;
        let self = this;
        this.isLoading = true;
        getCustomer()
          .collection("assettypes")
          .doc(id)
          .delete()
          .then(() => {
            self.$helpers.dispatch("showSuccess", {
              msg: "Asset type deleted successfully",
              vm: self,
            });
          })
          .catch((err) => {
            self.isLoading = false;
            self.$helpers.dispatch("showError2", {
              vm: self,
              err: err,
            });
          });
      }
    },
    getAssetCount(typeName) {
      if (this.assetCountDict[typeName] === undefined) {
        return this.showTypeCounts ? "0" : "";
      }

      return this.assetCountDict[typeName];
    },
    populateAssetCountDict() {
      if (!this.showTypeCounts) {
        this.assetCountDict = {};
        return;
      }

      const newDict = {};
      
      // Initialize counts to 0 for all known asset types
      this.allData.forEach((a) => {
        newDict[a.AssetTypeName] = 0;
      });

      // Tally up all assets in a single pass
      this.allAssets.forEach((f) => {
        const typeName = f.AssetTypeName;
        if (newDict[typeName] !== undefined) {
          newDict[typeName]++;
        } else {
          newDict[typeName] = 1;
        }
      });

      this.assetCountDict = newDict;
    },
    toggleShowTypeCounts() {
      this.showTypeCounts = !this.showTypeCounts;
      this.populateAssetCountDict();
      this.filterData(false);
    },

  },
};
</script>

